/**
 * Pure attachment helpers for the ticket detail page, extracted from
 * `TicketDetailPage.tsx` so they unit-test directly.
 */

/** True when a content-type is an image (drives the grid-vs-list split). */
export function isImage(contentType: string | undefined): boolean {
  return !!contentType && contentType.startsWith("image/");
}

/** Human-readable byte size (B / KB / MB) for an attachment's `byte_size`. */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
